import { isEmpty, isNaN, isNumber, merge, pickBy } from 'lodash-es'
import { useEffect, useRef } from 'react'

import { MANAGED_EVENT_TYPE } from 'constants/event_types'

import { useAccordion } from '../components/accordion'

export const filterEmptyValues = (values) => pickBy(values, (value) => value !== '' && value !== null)

export const isBlankValue = (value) => isEmpty(value) && (!isNumber(value) || isNaN(value))

export const sortHosts = (memberships) => memberships.sort(
  (membershipA, membershipB) => membershipA.name.localeCompare(membershipB.name)).sort(
  (membershipA, membershipB) => membershipA.is_pending - membershipB.is_pending)

export const getEventTypeLockAttributes = (eventType) => {
  const isLockable = eventType.type === MANAGED_EVENT_TYPE

  if (!isLockable) { return null }

  if (eventType.event_type_lock) {
    return eventType.event_type_lock
  }
  return {
    locking_rules: []
  }
}

export const formatEventTypeLockAttributes = (values) => {
  if (values.event_type_lock_attributes?.id) {
    return {
      id: values.event_type_lock_attributes.id,
      locking_rules: values.lockingRules
    }
  }
  return {
    locking_rules: values.lockingRules
  }
}

export const mergeArraysOfObjectsByKeys = (arrays, ...keys) => Object.values(
  merge({}, ...arrays.map((array) => {
    const keyedBy = {}

    array.forEach((object) => {
      const chosenKey = keys.find((key) => !!object[key])
      const mergeKey = `${chosenKey}-${object[chosenKey]}`

      keyedBy[mergeKey] = object
    })

    return keyedBy
  }))
)

export const valuesMapper = (values) => {
  const {
    allHostsLocationSelection: _,
    notetakerEnabledForEt: __,
    hasUserToggledNotetaker: ___,
    hasSeenNotetakerToggle: ____,
    ...rest
  } = values
  return rest
}

export const useFormInitialValidation = ({ isCreation, panelFieldsMapping, formInnerRef }) => {
  const formInitialValidationRef = useRef('not-initially-validated')
  const { openKeys, selectedKeys } = useAccordion()

  useEffect(() => {
    if (panelFieldsMapping && !isCreation && formInnerRef.current) {
      if (formInitialValidationRef.current === 'initially-validated') { return }

      if (formInitialValidationRef.current === 'not-initially-validated') {
        formInnerRef.current.validateForm().then((formErrors) => {
          if (!isEmpty(formErrors)) {
            const sectionsWithErrors = Object.keys(formErrors).reduce((sections, fieldName) => {
              const matchingSections = panelFieldsMapping.filter((mapping) => mapping[1].includes(fieldName))
              matchingSections.forEach((section) => sections.add(section[0]))
              return sections
            }, new Set())

            const closedSectionsWithErrors = sectionsWithErrors.difference(new Set(selectedKeys))

            if (closedSectionsWithErrors.size) {
              openKeys(closedSectionsWithErrors)
            }
          }

          formInitialValidationRef.current = 'initially-validated'
        })
      }
    }
  }, [formInnerRef, isCreation, panelFieldsMapping, openKeys, selectedKeys])
}
